const primary = {
    25: '#F5F5FF',
    50: '#F2F2FF',
    100: '#E8E7FF',
    200: '#D3D2FF',
    300: '#B4AEFF',
    400: '#8E80FF',
    500: '#6A4DFF',
    600: '#5F33FF',
    700: '#4816EB',
    800: '#3D12C5',
    900: '#3311A1'
}

export default primary
